import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import KioskLoadingIcon from '@/components/icons/KioskLoadingIcon';
import WarningIcon from '@/components/icons/WarningIcon';

type KioskLoadingProps = {
    show: boolean;
    content: React.ReactNode;
    footerShow?: boolean;
};

function KioskLoading({ show, content, footerShow = false }: KioskLoadingProps) {
    const { t } = useTranslation();

    return (
        <div className={clsx(styles.loading, { [styles.show]: show })}>
            <div className={styles.loading__content}>
                <KioskLoadingIcon className={styles.loading__icon} />
                <div className={styles.loading__text}>{content}</div>
            </div>
            {footerShow && (
                <div className={styles.loading__footer}>
                    <WarningIcon />
                    {t('loading.footer')}
                </div>
            )}
        </div>
    );
}

export default KioskLoading;
